import React from 'react';
import tableData from './fakeTasks';
import '../../../styles/dashboard/TasksNotes.css';

const TableOverdueShort = () => {
  return (
    <table className='table-tasks short-tables'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id}>
                <td>{data.title}</td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default TableOverdueShort;
